import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const FooterStyle: StyleExtend<Theme> = {
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: {
    xs: 2,
    sm: 5,
  },
};

export const FooterLinkStyle: StyleExtend<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  textTransform: 'none',
  textDecoration: 'none',
  fontWeight: 700,
  color: (theme) => theme.palette.customColors.copper,
};
